import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, resolveFilter as _resolveFilter, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "m-0"
};
const _hoisted_3 = {
  class: "m-3"
};
const _hoisted_4 = {
  class: "m-3 mb-0"
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "alert alert-info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_PiggyBankIcon = _resolveComponent("PiggyBankIcon");
  const _component_b_modal = _resolveComponent("b-modal");
  const _filter_billingType = _resolveFilter("billingType");
  return $props.subscriptiontype ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_createElementVNode("h2", _hoisted_2, [_createVNode(_component_b_icon, {
        icon: "tag-fill"
      }), _createTextVNode(" " + _toDisplayString($props.subscriptiontype.name), 1)])], undefined, true),
      _: 1
    }), _createVNode(_component_b_col, {
      cols: "3",
      xs: "12",
      class: "text-end"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {
        onRefresh: _cache[0] || (_cache[0] = $event => _ctx.$emit('refresh'))
      })], undefined, true),
      _: 3
    })], undefined, true),
    _: 3
  }), _createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_createElementVNode("p", _hoisted_3, [_createVNode(_component_b_icon, {
        icon: "info-circle-fill"
      }), _createTextVNode(" " + _toDisplayString($props.subscriptiontype.description), 1)])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  }), _cache[4] || (_cache[4] = _createElementVNode("hr", {
    class: "my-0 mx-3"
  }, null, -1)), _createVNode(_component_b_row, null, {
    default: _withCtx(() => [_createVNode(_component_b_col, null, {
      default: _withCtx(() => [_createElementVNode("h4", _hoisted_4, [_createVNode(_component_PiggyBankIcon), _createTextVNode(" " + _toDisplayString($props.subscriptiontype.localcurrencyformatted) + " Billed " + _toDisplayString(_filter_billingType($props.subscriptiontype.duration)) + " ", 1), _createElementVNode("a", {
        "uib-tooltip": "Click here to learn more...",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.openModal = true),
        style: {
          "cursor": "pointer"
        }
      }, [_createVNode(_component_b_icon, {
        icon: "info-circle-fill",
        variant: "info"
      })])]), $props.subscriptiontype.localcurrency !== 'USD' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("small", null, "* charges will be made in USD @ $" + _toDisplayString($props.subscriptiontype.amount) + ", international fees may apply", 1)])) : _createCommentVNode("", true)], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  }), _createVNode(_component_b_modal, {
    modelValue: _ctx.openModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.openModal = $event),
    title: $props.subscriptiontype.name,
    size: "lg",
    "ok-only": "",
    "ok-variant": "info"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("h3", null, "Info:", -1)), _createElementVNode("p", null, _toDisplayString($props.subscriptiontype.longdescription), 1)])], undefined, true),
    _: 1
  }, 8, ["modelValue", "title"])])) : _createCommentVNode("", true);
}